import HeaderLink from './HeaderLink'
import React, { useState, useEffect } from 'react';
import {Link} from "react-router-dom"

import { db, auth } from '../functions/firebaseFunctions'

export default function Header(props) {
    const {pageName,isMobNavOpen,setIsMobNavOpen, } = props
    const [hasNewMessages, setHasNewMessages]  = useState(false)
    
    useEffect(() => {
        const uid = auth.currentUser?.uid;
    
        if (uid) { // Добавляем проверку на наличие значения uid
            Promise.all([
                db.collection("conversations").where("userA", "==", uid).get(),
                db.collection("conversations").where("userB", "==", uid).get(),
            ])
            .then((snapshots) => {
                const newMess = snapshots.some((snapshot) =>
                snapshot.docs.some((doc) => doc.data().hasNewMessages === uid) 
                );
                console.log('newMess', newMess)
                setHasNewMessages(newMess);
            })
            .catch((error) => console.error(error));
        }
    }, []);

    return (
        <header >
            <div >
                
                {pageName !== 'Home' && pageName !== 'Profile' && <Link to="/">
                    <img alt="PartyLiveLogo" src='Logo.png' height={100}/>
                </Link>}
            </div>
            <nav id="desctopNav">
                <ul style={{display: 'flex', listStyle: 'none',}}>
                    <HeaderLink pageName={pageName} hasNewMessages={hasNewMessages} linkName="Home" link="/"/>
                    <HeaderLink pageName={pageName} hasNewMessages={hasNewMessages} linkName="Profile" link="/Profile/login"/>
                    <HeaderLink pageName={pageName} hasNewMessages={hasNewMessages} linkName="Browse" link="/browse/artists"/>
                    <HeaderLink pageName={pageName} hasNewMessages={hasNewMessages} linkName="BugReport" link="/"/>
                </ul>
            </nav>
            <button id="hamburgerOutline" >
                <svg id="hamburger"
                onClick={()=>{
                    if(isMobNavOpen){
                        setIsMobNavOpen(false)
                    }else{
                        setIsMobNavOpen(true)
                    }
                }} 
                width="20" height="17" viewBox="0 0 20 17" fill='var(--wht)' xmlns="http://www.w3.org/2000/svg">
                    <rect width="20" height="3"/>
                    <rect width="20" height="3" y="7"/>
                    <rect width="20" height="3" y="14"/>
                </svg>
            </button>
        </header>
    )
}